"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const locale = {
  layout_list_result: '{total} {total:Result/Results}',
  layout_list_selectedTotal: '( {selectedTotal} {selectedTotal:Result/Results} selected )',
  layout_basic_header_howTo: 'How to?',
  layout_basic_header_whatIs: "What's this?"
};
var _default = exports.default = locale;